import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { FilterSettingService } from "../../services/filter-setting.service";
import { Subscription } from "rxjs";
import { FilterModelDto } from "../../models/filter.model";
import { TableHeightService } from "../../services/table-height.service";

@Component({
  selector: "app-filter-block",
  templateUrl: "./filter-block.component.html",
  styleUrls: ["./filter-block.component.scss"],
})
export class FilterBlockComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() additional?: FilterModelDto[] | undefined;

  @Input() isOpenFilter = false;
  @Output() isOpenFilterChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() filterDataSetEvent: EventEmitter<any> = new EventEmitter<any>();

  type = "";

  aSub: Subscription[] = [];

  filterData: FilterModelDto[] = [];

  searchValue = "";
  isSearchResultOpen = false;
  searchTypeFilter: FilterModelDto | undefined;

  searchFilterResult: FilterModelDto[] = [];

  @ViewChild("filterBlock") filterBlock: ElementRef | undefined;

  sizeSub: ResizeObserver | undefined;

  constructor(
    private filterSettingService: FilterSettingService,
    private tableHeightService: TableHeightService
  ) {}

  ngOnInit() {
    this.initFilter();
  }

  ngAfterViewInit() {
    this.sizeSub = new ResizeObserver((entries, observer) => {
      for (const entry of entries) {
        const { height } = entry.contentRect;
        this.tableHeightService.filterBlockHeight$.next(height);
      }
    });

    this.sizeSub.observe(this.filterBlock?.nativeElement);
  }

  ngOnDestroy() {
    this.aSub.forEach((item) => item.unsubscribe());
    this.sizeSub?.unobserve(this.filterBlock?.nativeElement);
  }

  initFilter() {
    this.aSub.push(
      this.filterSettingService.filterSet$.subscribe({
        next: (res) => {
          this.changeFilterData(res);
        },
      })
    );

    this.aSub.push(
      this.filterSettingService.responseSearchData$.subscribe({
        next: (res) => {
          this.searchFilterResult = res;
        },
      })
    );

    // this.aSub.push(this.filterSettingService.filterItemReset$.subscribe({
    //   next: (res) => {
    //     this.deleteFilter(res)
    //   }
    // }))
  }

  changeFilterData(filter: FilterModelDto) {
    for (let i = 0; i < this.filterData.length; i++) {
      if (this.filterData[i].fieldName === filter.fieldName) {
        this.filterData.splice(i, 1);
        this.filterData.push(filter);
        return;
      }
    }
    this.filterData.push(filter);
  }

  deleteFilter(filter: FilterModelDto) {
    this.searchValue = "";
    this.searchTypeFilter = undefined;
    this.type = "";
    this.filterSettingService.filterAdditionalReset$.next();
    this.filterSettingService.filterItemReset$.next(filter);
    for (let i = 0; i < this.filterData.length; i++) {
      if (this.filterData[i].fieldName === filter.fieldName) {
        this.filterData.splice(i, 1);
        break;
      }
    }

    !this.filterData.length && this.resetAllFilters();
  }

  closeFilterBlock() {
    this.isOpenFilter = false;
    this.isOpenFilterChange.emit(this.isOpenFilter);
  }

  setAdditionalType(filter: FilterModelDto) {
    this.searchFilterResult = [];
    this.searchValue = "";
    this.type = `(${filter.description})`;
    this.searchTypeFilter = filter;
  }

  searchDataBase(value: string) {
    if (this.searchTypeFilter && value.trim().length >= 1) {
      this.searchTypeFilter.value = value;
      this.filterSettingService.inputSearch$.next(this.searchTypeFilter);
    } else {
      this.filterSettingService.filterSearchWord$.next(this.searchValue);
    }

    if (!value.trim().length) {
      this.searchFilterResult = [];
    }
  }

  selectValue(filter: FilterModelDto) {
    this.isSearchResultOpen = false;
    this.changeFilterData(filter);

    this.searchValue = "";
    this.searchTypeFilter = undefined;
    this.type = "";
    this.filterSettingService.filterSelected$.next();
  }

  resetAllFilters() {
    this.filterData = [];
    this.searchValue = "";
    this.searchTypeFilter = undefined;
    this.type = "";
    this.filterSettingService.filterAllReset$.next();
  }

  sendRequestFilter() {
    const filter: any = {};
    this.filterData.forEach((item) => {
      filter[item.fieldName] = item.value.toString();
    });

    this.filterSettingService.filterSetData$.next(filter);
  }

  onValueChange(value: any): void {
    const trimmedValue = value?.trim();

    if (trimmedValue) {
      console.log("")
    } else {
      this.resetAllFilters();
    }
  }
}
